// test1549
(1549 && 0);
